module.exports = __webpack_public_path__ + "static/media/brand-story-img2.95a75bcb.png";